<template>
    <div>
        <div class="title">
            <h1> 个人简历 </h1>
            <p> 点击
                <a @click="download">这里</a>
                下载我当前版本的简历（2026年4月更新） <br>

            </p>
        </div>
        <div class="content">
            <el-row>
                <el-col :span="2"><div class="grid-content"></div></el-col>
                <el-col :span="6">
                    <div class="photo">
                        <img src="../assets/facephoto.webp">
                    </div>
                </el-col>
                <el-col :span="14">
                    <div class="content-text">
                        <h2>教育背景</h2>
                        <div class="bulletlist">
                            <el-row>
                                <el-col :span="2">
                                    <div class="bullet">
                                    &#8226;
                                    </div>
                                </el-col>
                                <el-col :span="22">
                                    <div>
                                    2019-2024 . 设计科学博士，浙江大学计算机科学与技术学院
                                    </div>
                                </el-col>
                            </el-row>
                        </div>
                        <div class="bulletlist">
                            <el-row>
                                <el-col :span="2">
                                    <div class="bullet">
                                        &#8226;
                                    </div>
                                </el-col>
                                <el-col :span="22">
                                    <div>
                                        2016 . 交换生项目（工程产品开发 EPD），新加坡科技与设计大学（SUTD）<br>
                                    </div>
                                </el-col>
                            </el-row>
                        </div>
                        <div class="bulletlist">
                            <el-row>
                                <el-col :span="2">
                                    <div class="bullet">
                                        &#8226;
                                    </div>
                                </el-col>
                                <el-col :span="22">
                                    <div>
                                        2015-2019 . 工业设计学士，浙江大学计算机科学与技术学院<br>
                                    </div>
                                </el-col>
                            </el-row>
                        </div>
                        <h2>荣誉与奖励</h2>
                        <div class="bulletlist">
                            <el-row>
                                <el-col :span="2">
                                    <div class="bullet">
                                        &#8226;
                                    </div>
                                </el-col>
                                <el-col :span="22">
                                    <div>
                                        2025 . 中国国际大学生创新大赛（原“互联网+”）省赛金奖（项目负责人）<br>
                                    </div>
                                </el-col>
                            </el-row>
                        </div>
                        <div class="bulletlist">
                            <el-row>
                                <el-col :span="2">
                                    <div class="bullet">
                                        &#8226;
                                    </div>
                                </el-col>
                                <el-col :span="22">
                                    <div>
                                        2024 . 浙江大学校级优秀毕业生<br>
                                    </div>
                                </el-col>
                            </el-row>
                        </div>
                        <div class="bulletlist">
                            <el-row>
                                <el-col :span="2">
                                    <div class="bullet">
                                        &#8226;
                                    </div>
                                </el-col>
                                <el-col :span="22">
                                    <div>
                                        2022-2023 . 浙江大学计算机科学与技术学院优秀研究生<br>
                                    </div>
                                </el-col>
                            </el-row>
                        </div>
                        <div class="bulletlist">
                            <el-row>
                                <el-col :span="2">
                                    <div class="bullet">
                                        &#8226;
                                    </div>
                                </el-col>
                                <el-col :span="22">
                                    <div>
                                        2021-2022 . 浙江大学计算机科学与技术学院社会实践先进个人<br>
                                    </div>
                                </el-col>
                            </el-row>
                        </div>
                        <div class="bulletlist">
                            <el-row>
                                <el-col :span="2">
                                    <div class="bullet">
                                        &#8226;
                                    </div>
                                </el-col>
                                <el-col :span="22">
                                    <div>
                                        2020-2021 . 浙江大学计算机科学与技术学院优秀研究生<br>
                                    </div>
                                </el-col>
                            </el-row>
                        </div>
                        <div class="bulletlist">
                            <el-row>
                                <el-col :span="2">
                                    <div class="bullet">
                                        &#8226;
                                    </div>
                                </el-col>
                                <el-col :span="22">
                                    <div>
                                        2019 . 浙江大学计算机科学与技术学院博士新生奖学金<br>
                                    </div>
                                </el-col>
                            </el-row>
                        </div>
                        <div class="bulletlist">
                            <el-row>
                                <el-col :span="2">
                                    <div class="bullet">
                                        &#8226;
                                    </div>
                                </el-col>
                                <el-col :span="22">
                                    <div>
                                        2019 . 浙江大学计算机科学与技术专业本科优秀毕业论文<br>
                                    </div>
                                </el-col>
                            </el-row>
                        </div>
                        <div class="bulletlist">
                            <el-row>
                                <el-col :span="2">
                                    <div class="bullet">
                                        &#8226;
                                    </div>
                                </el-col>
                                <el-col :span="22">
                                    <div>
                                        2018 . 第四届中国研究生移动应用创新大赛全国一等奖<br>
                                    </div>
                                </el-col>
                            </el-row>
                        </div>
                        <div class="bulletlist">
                            <el-row>
                                <el-col :span="2">
                                    <div class="bullet">
                                        &#8226;
                                    </div>
                                </el-col>
                                <el-col :span="22">
                                    <div>
                                        2018 . 中国大学生移动应用创新大赛全国三等奖<br>
                                    </div>
                                </el-col>
                            </el-row>
                        </div>
                        <div class="bulletlist">
                            <el-row>
                                <el-col :span="2">
                                    <div class="bullet">
                                        &#8226;
                                    </div>
                                </el-col>
                                <el-col :span="22">
                                    <div>
                                        2018 . 浙江大学计算机科学与技术学院优秀本科生、学业二等奖学金<br>
                                    </div>
                                </el-col>
                            </el-row>
                        </div>
                        <div class="bulletlist">
                        <el-row>
                            <el-col :span="2">
                                <div class="bullet">
                                    &#8226;
                                </div>
                            </el-col>
                            <el-col :span="22">
                                <div>
                                    2017 . 浙江大学计算机科学与技术学院优秀本科生、学业二等奖学金<br>
                                </div>
                            </el-col>
                        </el-row>
                    </div>
                        <h2>交流经历</h2>
                        <div class="bulletlist">
                            <el-row>
                                <el-col :span="2">
                                    <div class="bullet">
                                        &#8226;
                                    </div>
                                </el-col>
                                <el-col :span="22">
                                    <div>
                                        2019 . 亚洲大学生集体行动交流项目（CAMPUS Asia），日本千叶大学
                                    </div>
                                </el-col>
                            </el-row>
                        </div>
                        <div class="bulletlist">
                            <el-row>
                                <el-col :span="2">
                                    <div class="bullet">
                                        &#8226;
                                    </div>
                                </el-col>
                                <el-col :span="22">
                                    <div>
                                        2018 . 亚洲大学生集体行动交流项目（CAMPUS Asia），韩国延世大学
                                    </div>
                                </el-col>
                            </el-row>
                        </div>
                        <div class="bulletlist">
                            <el-row>
                                <el-col :span="2">
                                    <div class="bullet">
                                        &#8226;
                                    </div>
                                </el-col>
                                <el-col :span="22">
                                    <div>
                                        2016 . 新加坡科技与设计大学（SUTD）交换项目
                                    </div>
                                </el-col>
                            </el-row>
                        </div>
                        <h2>项目实践</h2>
                        <div class="bulletlist">
                            <el-row>
                                <el-col :span="2">
                                    <div class="bullet">
                                        &#8226;
                                    </div>
                                </el-col>
                                <el-col :span="22">
                                    <div class="Chinese">
                                        2020年01月 - 2022年09月 . 【国家重点研发计划子课题】复杂文物的材质模型研究（2019YFC1521103）
                                        以骨干成员身份对于半透明文物三维扫描的模型存在缺陷的问题提出了基于纹理映射的解决方案，构建多种玉石的3S材质模型，开发批量渲染插件，提升了半透明文物数字化的视觉真实感，提高了博物馆文物数字化渲染效率。
                                    </div>
                                    <div class="English">
                                        2020.01 - 2022.09 . 【National Key R&amp;D Program (sub-project)】Research on material models of complex cultural relics (2019YFC1521103). As a core member, I proposed a texture-mapping-based solution to defects in 3D scanned models of semi-transparent cultural relics, built subsurface-scattering (3S) material models for multiple jade types, developed a batch rendering plugin, improved visual realism of digitized semi-transparent relics, and increased rendering efficiency for museum digitization.
                                    </div>
                                </el-col>
                            </el-row>
                        </div>
                        <div class="bulletlist">
                            <el-row>
                                <el-col :span="2">
                                    <div class="bullet">
                                        &#8226;
                                    </div>
                                </el-col>
                                <el-col :span="22">
                                    <div class="Chinese">
                                        2025年01月 - 2026年12月 . 【尖兵领雁项目】面向玩具产品的大型直播选品中心运营系统研发及应用（2025C03009）
                                        作为骨干成员，主导系统的需求分析与架构设计，攻克玩具品类智能匹配、多端数据协同等技术难点，支撑项目实现从传统选品向数字化、智能化运营的升级。
                                    </div>
                                    <div class="English">
                                        2025.01 - 2026.12 . 【Jianbing-Lingyan Program】R&amp;D and application of a large live-streaming product-selection center for toy products (2025C03009). As a core member, I led requirements analysis and system architecture design, and addressed challenges such as intelligent toy-category matching and multi-terminal data collaboration, supporting the project's transition from traditional to digital, intelligent operations.
                                    </div>
                                </el-col>
                            </el-row>
                        </div>
                        <div class="bulletlist">
                            <el-row>
                                <el-col :span="2">
                                    <div class="bullet">
                                        &#8226;
                                    </div>
                                </el-col>
                                <el-col :span="22">
                                    <div class="Chinese">
                                        2020年01月 - 2022年01月 . 【浙江省基础公益研究计划项目】儿童读写障碍研究及康复应用（LGF20F020019）
                                        作为骨干成员，负责儿童读写能力评估、数据采集与康复方案设计与实验开展，助力构建科学、可落地的儿童读写障碍早期干预与康复体系。
                                    </div>
                                    <div class="English">
                                        2020.01 - 2022.01 . 【Zhejiang Provincial Basic Public Welfare Research Program】Research and rehabilitation application for children with dyslexia (LGF20F020019). As a core member, I was responsible for literacy assessment, data collection, rehabilitation protocol design and experiments, contributing to a scientific, actionable early intervention and rehabilitation system for developmental dyslexia.
                                    </div>
                                </el-col>
                            </el-row>
                        </div>
                        <div class="bulletlist">
                            <el-row>
                                <el-col :span="2">
                                    <div class="bullet">
                                        &#8226;
                                    </div>
                                </el-col>
                                <el-col :span="22">
                                    <div class="Chinese">
                                        2023年10月 - 2025年12月 . 【浙江省文化和旅游科技创新示范项目】嘉善文化资源数字化与公共文旅云服务研究
                                        作为骨干成员，基于嘉善文旅资源数字化建设工程，研发建设嘉善文旅服务云平台，满足嘉善文化资源的检索、分享等文旅资源展示功能，同时包含交通、路线、气象、民宿预定、文化活动购票等文旅服务功能。
                                    </div>
                                    <div class="English">
                                        2023.10 - 2025.12 . 【Zhejiang Cultural and Tourism S&amp;T Innovation Demonstration Project】Digitalization of Jiashan cultural resources and public cultural-tourism cloud services. As a core member, based on Jiashan's cultural-tourism resource digitization initiative, I helped develop the Jiashan cultural-tourism service cloud platform, supporting retrieval, sharing and display of resources, as well as transportation, routes, weather, homestay booking, cultural event ticketing, and related services.
                                    </div>
                                </el-col>
                            </el-row>
                        </div>
                        <div class="bulletlist">
                            <el-row>
                                <el-col :span="2">
                                    <div class="bullet">
                                        &#8226;
                                    </div>
                                </el-col>
                                <el-col :span="22">
                                    <div class="Chinese">
                                        2021年09月 - 2023年12月 . 【企业合作项目】AR辅助敷设系统及一体化数据管控平台研发
                                        作为主要参与者为国内某知名航空工业集团设计与开发基于AR的线缆敷设辅助系统，构建数据管理中台。使操作人员可以更轻松地完成大飞机线缆的布线设计验证、布线操作及布线结果检验等操作。
                                    </div>
                                    <div class="English">
                                        2021.09 - 2023.12 . 【Industry collaboration】AR-assisted routing system and integrated data management platform. As a major participant, I contributed to designing and developing an AR-assisted cable routing system and data management middleware for a leading domestic aviation industry group, enabling operators to complete wiring design verification, routing operations, and inspection for large aircraft more efficiently.
                                    </div>
                                </el-col>
                            </el-row>
                        </div>
                        <div class="section-heading">
                            <h2>研究成果</h2>
                            <a
                                target="_blank"
                                rel="noopener noreferrer"
                                href="https://scholar.google.com/citations?hl=en&user=8JnbAC4AAAAJ"
                            >
                                <input class="detailBTN" type="button" value="谷歌学术页面">
                            </a>
                        </div>
                        <div class="bulletlist">
                            <el-row>
                                <el-col :span="2">
                                    <div class="bullet">
                                        &#8226;
                                    </div>
                                </el-col>
                                <el-col :span="22">
                                    <div>
                                        <b>Gong, Q.*</b>, Chen, C., Wang, K., Li, C., Qin, Y., Qiao, X., Zou, N. (2026). From Service Dogs to Robots: A Bio-inspired Framework for Intuitive Intent Prediction in Mixed Reality. <i>International Journal of Human–Computer Interaction</i>, 1–19.（TOP顶刊，SCI&amp;CCF-B，Q1，唯一一作）
                                    </div>
                                </el-col>
                            </el-row>
                        </div>
                        <div class="bulletlist">
                            <el-row>
                                <el-col :span="2">
                                    <div class="bullet">
                                        &#8226;
                                    </div>
                                </el-col>
                                <el-col :span="22">
                                    <div>
                                        <b>Gong, Q.*</b>, Wang, Z., Chen, Y., Zou, N. (2024). ‘Rhetoric’ in the design process: The role of prop-based virtual reality storytelling in user-centred product conceptual design. <i>Design Journal</i>, 27(6).（AHCI，唯一一作）
                                    </div>
                                </el-col>
                            </el-row>
                        </div>
                        <div class="bulletlist">
                            <el-row>
                                <el-col :span="2">
                                    <div class="bullet">
                                        &#8226;
                                    </div>
                                </el-col>
                                <el-col :span="22">
                                    <div>
                                        <b>Gong, Q.*</b>, Zou, N., Yang, W. et al. (2024). User experience model and design strategies for virtual reality-based cultural heritage exhibition. <i>Virtual Reality</i>, 28(2).（SCI，Q1，唯一一作）
                                    </div>
                                </el-col>
                            </el-row>
                        </div>
                        <div class="bulletlist">
                            <el-row>
                                <el-col :span="2">
                                    <div class="bullet">
                                        &#8226;
                                    </div>
                                </el-col>
                                <el-col :span="22">
                                    <div>
                                        Zou, N., <b>Gong, Q.*</b>, Li, X., Zhao, Z., Chai, C. (2023). Context Connection: A Product Creative Design Method for Integrating Design Materials and Design Resources. <i>Creativity Research Journal</i>, 36(4). （SSCI，Q1，学生一作）
                                    </div>
                                </el-col>
                            </el-row>
                        </div>
                        <div class="bulletlist">
                            <el-row>
                                <el-col :span="2">
                                    <div class="bullet">
                                        &#8226;
                                    </div>
                                </el-col>
                                <el-col :span="22">
                                    <div>
                                        Zou, N., <b>Gong, Q.*</b>, Chai, Q., &amp; Chai, C. (2023). The role of virtual reality technology in conceptual design: Positioning, applications, and value. <i>Digital Creativity</i>, 34(1). （AHCI，学生一作）
                                    </div>
                                </el-col>
                            </el-row>
                        </div>
                        <div class="bulletlist">
                            <el-row>
                                <el-col :span="2">
                                    <div class="bullet">
                                        &#8226;
                                    </div>
                                </el-col>
                                <el-col :span="22">
                                    <div>
                                        Zou, N., <b>Gong, Q.*</b>, Zhou, J., Chen, P., Kong, W., &amp; Chai, C. (2021). Value-based model of user interaction design for virtual museum. <i>CCF Transactions on Pervasive Computing and Interaction</i>, 3(2), 112–128. （SCI&amp;CCF-B，学生一作）
                                    </div>
                                </el-col>
                            </el-row>
                        </div>
                        <div class="bulletlist">
                            <el-row>
                                <el-col :span="2">
                                    <div class="bullet">
                                        &#8226;
                                    </div>
                                </el-col>
                                <el-col :span="22">
                                    <div>
                                        Zou, N., Chen, Y., Chen, P., <b>Gong, Q.*</b> (2025). Research on multimodal interaction system based on cognitive style in virtual historical and cultural scenes. <i>Design and Artificial Intelligence</i>, 1(4): 100052. （通讯作者）
                                    </div>
                                </el-col>
                            </el-row>
                        </div>
                        <div class="bulletlist">
                            <el-row>
                                <el-col :span="2">
                                    <div class="bullet">
                                        &#8226;
                                    </div>
                                </el-col>
                                <el-col :span="22">
                                    <div>
                                        Zhou, Z., <b>Gong, Q.*</b>, Qi, Z., &amp; Sun, L. (2019). ML-Process Canvas: A Design Tool to Support the UX Design of Machine Learning-Empowered Products. <i>Extended Abstracts of the 2019 CHI Conference on Human Factors in Computing Systems – CHI EA ’19</i>, 1–6. （CCF-A，顶会，二作）
                                    </div>
                                </el-col>
                            </el-row>
                        </div>
                        <div class="bulletlist">
                            <el-row>
                                <el-col :span="2">
                                    <div class="bullet">
                                        &#8226;
                                    </div>
                                </el-col>
                                <el-col :span="22">
                                    <div>
                                        Li, C., <b>Gong, Q.*</b>, Yu, Z., Zhai, Y. (2025). An Imbalanced Fault Diagnosis Framework Based on Subdomain Adaptation Mechanism of Dual-Branch Network. <i>2025 IEEE International Conference on Systems, Man, and Cybernetics (SMC)</i>, Vienna, Austria, pp. 5197–5202.（CCF-C，二作）
                                    </div>
                                </el-col>
                            </el-row>
                        </div>
                        <div class="bulletlist">
                            <el-row>
                                <el-col :span="2">
                                    <div class="bullet">
                                        &#8226;
                                    </div>
                                </el-col>
                                <el-col :span="22">
                                    <div>
                                        邹宁, 侯志鹏, 柴一伟, 孔文琦, 赵博, <b>龚卿</b>* &amp; 方强. (2025). 虚拟环境下的光照体验设计. <i>浙江大学学报（工学版）</i>, 59(10).
                                    </div>
                                </el-col>
                            </el-row>
                        </div>
                        <div class="bulletlist">
                            <el-row>
                                <el-col :span="2">
                                    <div class="bullet">
                                        &#8226;
                                    </div>
                                </el-col>
                                <el-col :span="22">
                                    <div>
                                        Zou, N., Zhao, Z., Yang, Y., Zhou, J., Zhang, X., Li, X., <b>Gong, Q.*</b>, Wu, Y., &amp; Zheng, Z. (2024). Tangible Interaction Design in Music Intervention for Chinese Children with Developmental Dyslexia. <i>International Journal of Human–Computer Interaction</i>, 41(8), 4851–4872.
                                    </div>
                                </el-col>
                            </el-row>
                        </div>
                        <div class="bulletlist">
                            <el-row>
                                <el-col :span="2">
                                    <div class="bullet">
                                        &#8226;
                                    </div>
                                </el-col>
                                <el-col :span="22">
                                    <div>
                                        Zhou, Z., Sun, L., Zhang, Y., Liu, X., &amp; <b>Gong, Q.*</b> (2020). ML Lifecycle Canvas: Designing Machine Learning–Empowered UX with Material Lifecycle Thinking. <i>Human–Computer Interaction</i>, 35(5–6), 362–386.
                                    </div>
                                </el-col>
                            </el-row>
                        </div>
                        <h2>专利</h2>
                        <div class="bulletlist">
                            <el-row>
                                <el-col :span="2">
                                    <div class="bullet">
                                        &#8226;
                                    </div>
                                </el-col>
                                <el-col :span="22">
                                    <div>
                                        一种可折叠式的三维信息采集装置，发明专利，CN115002439B，授权时间：2023/6/2
                                    </div>
                                </el-col>
                            </el-row>
                        </div>
                        <div class="bulletlist">
                            <el-row>
                                <el-col :span="2">
                                    <div class="bullet">
                                        &#8226;
                                    </div>
                                </el-col>
                                <el-col :span="22">
                                    <div>
                                        一种基于用户需求和用户动机的产品定义重要性分析方法，发明专利，CN115600380A，申请公开时间：2023/1/13
                                    </div>
                                </el-col>
                            </el-row>
                        </div>
                        <div class="bulletlist">
                            <el-row>
                                <el-col :span="2">
                                    <div class="bullet">
                                        &#8226;
                                    </div>
                                </el-col>
                                <el-col :span="22">
                                    <div>
                                        一种虚拟现实用手持触觉反馈装置和重量仿真模拟方法，发明专利，CN118012260，申请公开时间：2024.5.10
                                    </div>
                                </el-col>
                            </el-row>
                        </div>

                    </div>
                </el-col>
                <el-col :span="2"><div class="grid-content"></div></el-col>
            </el-row>
        </div>


    </div>
</template>

<script>

    import download from "downloadjs";
    export default {
        name: "CVZh",
        methods: {
            download() {
                download("/GONGQing_resume.pdf");
            },
        }
    }

</script>

<style scoped>
    .Chinese{
        display:block;
    }
    .English{
        display:none;
    }
    .bullet{
        margin-left: 20px;
    }
    .bulletlist{
        margin-top: 10px;
        line-height: 25px;
        font-size: 15px;
        font-weight: 100;
        color: #333;

    }
    h2{
        font-size:24px;
        font-weight: 100;
        letter-spacing:2px;
        color: #333333;
    }
    .section-heading{
        display: flex;
        align-items: center;
        gap: 16px;
        margin-top: 24px;
    }
    .section-heading h2{
        margin: 0;
    }
    .detailBTN{
        margin-top: 2px;
        cursor:pointer;
        width: 150px;
        height: 50px;
        background-color: #333;
        color: #fff;
        border: none;
    }
    .detailBTN:hover{
        opacity: 80%;
    }
    .content-text{
        margin-left: 50px;
        margin-top: -25px;
    }
    .content{
        margin-top: 50px;
    }
    .grid-content {
        min-height: 36px;
        border:none;

    }
    .photo img{
        width: 100%;
    }
    .title{
        margin-top: 100px;
        text-align: center;

    }
    .title a{
        color: #333;
        cursor:pointer;
       text-decoration: none;
    }
    .title p{
        color: #aaa;
        line-height: 30px;
    }
    .title h1{
        font-size:30px;
        font-weight: 100;
        letter-spacing:6px;
        color: #333333;
    }
</style>
